module.exports = "/_next/static/images/3bc7e55799cb98c5707d5753c38a3dc2-withdrawal.svg.webp";